/* unplugin-vue-components disabled */import script from "./NavItem.vue?vue&type=script&setup=true&lang=js"
export * from "./NavItem.vue?vue&type=script&setup=true&lang=js"

import "./NavItem.vue?vue&type=style&index=0&id=2831f0f1&lang=less&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2831f0f1"]])

export default __exports__